import { render, staticRenderFns } from "./yc-annals-target-summary.vue?vue&type=template&id=1c97ef33&scoped=true&"
import script from "./yc-annals-target-summary.vue?vue&type=script&lang=js&"
export * from "./yc-annals-target-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c97ef33",
  null
  
)

export default component.exports